import { ShoppingCart } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { formatUsd } from '@/features/projects/rollup-bom'

interface OrderAtSourceButtonProps {
  sourceDisplayName: string
  itemCount: number
  subtotalCents: number
  onClick: () => void
}

/**
 * Phase 17 — single button per Source rendered below the BOM panel. Click opens the Cart Preview
 * modal for that source. Auto-detects "1 item" vs "N items" copy; always shows the subtotal so
 * the user has a one-glance estimate before clicking.
 */
export const OrderAtSourceButton = ({
  sourceDisplayName,
  itemCount,
  subtotalCents,
  onClick,
}: OrderAtSourceButtonProps) => (
  <Button
    variant="outline"
    size="sm"
    onClick={onClick}
    className="gap-2"
    aria-label={`Open cart preview for ${sourceDisplayName}`}
  >
    <ShoppingCart className="h-3.5 w-3.5" aria-hidden />
    <span>
      Order at {sourceDisplayName} · {itemCount} {itemCount === 1 ? 'item' : 'items'} · ~
      {formatUsd(subtotalCents)}
    </span>
  </Button>
)
